import { render, staticRenderFns } from "./scenery-box.vue?vue&type=template&id=1c6eb63a&scoped=true&"
import script from "./scenery-box.vue?vue&type=script&lang=js&"
export * from "./scenery-box.vue?vue&type=script&lang=js&"
import style0 from "./scenery-box.vue?vue&type=style&index=0&id=1c6eb63a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6eb63a",
  null
  
)

export default component.exports